/**
 * POSTLAUNCH-V6 · P2-#10 (Sa 06.09.2026) — Bring-a-Friend-Banner.
 *
 * Permanent sichtbar auf Dashboard über den Right-Rail-Elementen.
 * Klick navigiert zu /profil → Referral-Sektion (P2-#9).
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";

export default function BringAFriendBanner() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate("/profil#referral")}
      data-testid="bring-a-friend-banner"
      className="w-full text-left rounded-2xl bg-gradient-to-br from-amber-50 to-white dark:from-amber-950/40 dark:to-slate-900 border border-amber-200 dark:border-amber-800/60 p-5 hover:shadow-md transition-all group"
      aria-label="Bring a Friend — Referral öffnen"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-300 flex items-center justify-center flex-shrink-0">
          <Gift className="w-4 h-4" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-bold uppercase tracking-widest text-amber-700 dark:text-amber-300">
            Bring a Friend
          </p>
          <p className="mt-1 text-sm font-bold text-slate-900 dark:text-white leading-snug">
            Lade einen Freund ein — du bekommst 30 Tage Pro Solo gratis.
          </p>
          <p className="mt-2 inline-flex items-center gap-1 text-xs font-bold text-amber-700 dark:text-amber-300 group-hover:underline">
            Jetzt einladen <ArrowRight className="w-3 h-3" />
          </p>
        </div>
      </div>
    </button>
  );
}
